import type { PRIORITIES } from '@/constants/common';
import type {
  AIResponseActionSettingsPayload,
  SettingsTypes
} from '@/pages/Administration/Administration.types';
import type { components } from '@/types/openapi';

export enum AIResponseActionModeEnum {
  DISABLED = 'disabled',
  MANUAL = 'manual',
  AGENTIC = 'agentic'
}

export type AIResponseActionKeys =
  | 'host_isolation'
  | 'invalidate_session_token'
  | 'identity_isolation';
export type AIResponseActionPriority = Exclude<
  (typeof PRIORITIES)[number],
  'P5'
>;

export type AIResponseActionDTO =
  components['schemas']['AIResponseActionDefinition'];

export type AIResponseActionConfig = Record<
  AIResponseActionKeys,
  Record<AIResponseActionPriority, AIResponseActionModeEnum>
>;

export type AIResponseActionMatrixProps = {
  handleSave: (
    updatedOrgInfo: AIResponseActionSettingsPayload
  ) => Promise<unknown>;
  isSaving: boolean;
  isSettingsError: boolean;
  orgInfo?: SettingsTypes;
  organizationLabel: string;
  retrySettings: () => void;
};

export type HostIsolationExclusions = {
  excluded_host_names: string[];
  excluded_asset_types: components['schemas']['AssetType'][];
  excluded_asset_subtypes: components['schemas']['AssetSubType'][];
  excluded_asset_tags: string[];
};
